/* eslint-disable */
// The approved preview hero, using the route-owned lifecycle and media controller.
export default function runHeroSpotlight(environment) {
  const { document, window, matchMedia, requestAnimationFrame, cancelAnimationFrame, IntersectionObserver, addEventListener } = environment;
  const root = document.getElementById('mr-main-one');
  const word = document.getElementById('mrh-word');
  if (!root || !word) return;
  const dim = root.querySelector('.mrh__dim');
  const touch = matchMedia('(hover: none), (pointer: coarse), (max-width: 760px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false, touched = false, pointerActive = false, frame = 0, sweep = 0, clientX = 0, clientY = 0;
  let lastSweep = 0, elapsed = 0, dirty = true, background, letters, pad;
  function measure() {
    background = root.getBoundingClientRect();
    letters = word.getBoundingClientRect();
    pad = parseFloat(getComputedStyle(word).paddingLeft) || 0;
    dirty = false;
  }
  function light(x, y) {
    if (dirty) measure();
    // Localize the moving gradient instead of restyling the whole hero tree.
    dim.style.setProperty('--lx', (x - background.left).toFixed(1) + 'px');
    dim.style.setProperty('--ly', (y - background.top).toFixed(1) + 'px');
    word.style.setProperty('--sx', (x - letters.left).toFixed(1) + 'px');
    word.style.setProperty('--sy', (y - letters.top).toFixed(1) + 'px');
    const overWord = x >= letters.left && x <= letters.right && y >= letters.top && y <= letters.bottom;
    word.setAttribute('aria-pressed', String(overWord));
  }
  function centerLight() {
    measure();
    light(letters.left + pad + (letters.width - pad * 2) * .3, letters.top + letters.height * .52);
  }
  function stopSweep() { cancelAnimationFrame(sweep); sweep = 0; lastSweep = 0; }
  function sweepLight(now) {
    if (touched || !touch.matches || reduce.matches || !visible || document.hidden) { stopSweep(); return; }
    sweep = requestAnimationFrame(sweepLight);
    // A slow decorative sweep needs no more than 30 updates per second.
    if (lastSweep && now - lastSweep < 1000 / 30 - 1) return;
    elapsed += lastSweep ? Math.min(50, now - lastSweep) : 0;
    lastSweep = now;
    let progress = (elapsed / 5600) % 2;
    if (progress > 1) progress = 2 - progress;
    const eased = progress < .5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
    if (dirty) measure();
    light(letters.left + letters.width * (.08 + eased * .84), letters.top + letters.height * .52);
  }
  function syncActivity() {
    const paused = !visible || document.hidden || reduce.matches;
    root.classList.toggle('is-hero-offscreen', paused);
    stopSweep();
    if (paused) { cancelAnimationFrame(frame); frame = 0; }
    if (!paused && touch.matches && !touched) sweep = requestAnimationFrame(sweepLight);
  }
  function point(event) {
    if (event.type === 'pointerdown' && event.button !== 0) return;
    if (event.type === 'pointerdown') pointerActive = true;
    if (event.type === 'pointermove' && touch.matches && !pointerActive) return;
    touched = true; stopSweep();
    root.classList.remove('is-keyboard-revealed');
    clientX = event.clientX; clientY = event.clientY;
    if (frame) return;
    frame = requestAnimationFrame(() => { light(clientX, clientY); frame = 0; });
  }
  root.addEventListener('pointermove', point);
  root.addEventListener('pointerdown', point);
  for (const type of ['pointerup', 'pointercancel']) addEventListener(type, () => { pointerActive = false; }, { passive: true });
  word.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault(); touched = true; stopSweep();
    const revealed = root.classList.toggle('is-keyboard-revealed');
    centerLight(); word.setAttribute('aria-pressed', String(revealed));
  });
  function syncInput() { root.classList.remove('is-keyboard-revealed'); centerLight(); syncActivity(); }
  touch.addEventListener('change', syncInput);
  reduce.addEventListener('change', syncActivity);
  document.addEventListener('visibilitychange', syncActivity);
  addEventListener('resize', centerLight, { passive: true });
  addEventListener('scroll', () => { dirty = true; }, { passive: true });
  new IntersectionObserver(entries => { visible = entries[0].isIntersecting; dirty = true; syncActivity(); }, { threshold: 0 }).observe(root);
  if (document.fonts?.ready) document.fonts.ready.then(centerLight);
  syncInput();
}
